export default "__VITE_ASSET__D_e9p4OP__"